export default __webpack_public_path__ + "static/media/student2.a60f6678.png";